export default "/images/settings-icon.svg?745f7cb826f386c98f6517ee7ccd52a2";